import { createSelector } from '@reduxjs/toolkit';
import { selectExchangesList } from '@skynet/data-shared-exchanges';
import type { ExchangesState, JsonExchange } from '@skynet/data-shared-exchanges';

import type { JsonServer, JsonServerExchange, ServersState } from './types';

/**
 * The slice view this package reads: the servers slice mounted at the root
 * `admin` key, and the MM shared exchanges slice at `exchanges` to join each
 * server with its exchange.
 */
export interface Store {
  admin: ServersState;
  exchanges: ExchangesState;
}

export const selectServersError = (store: Pick<Store, 'admin'>) => store.admin.error;

export const selectServers = (store: Pick<Store, 'admin'>) => store.admin.servers;
export const selectIsServersLoading = (store: Pick<Store, 'admin'>) => store.admin.isServersLoading;

const selectExchanges = (store: Store) => selectExchangesList(store.exchanges);

/** Servers table rows: every server with the exchange of the same id, if known. */
export const selectServersWithExchanges = createSelector(
  selectServers,
  selectExchanges,
  (servers: JsonServer[], exchanges: JsonExchange[]): JsonServerExchange[] =>
    servers.map((server) => ({
      ...server,
      exchange: exchanges.find((exchange) => exchange.id === server.id),
    })),
);
